import { render, staticRenderFns } from "./FullScreenDocumentViewer.vue?vue&type=template&id=32b0cc38"
import script from "./FullScreenDocumentViewer.vue?vue&type=script&lang=js"
export * from "./FullScreenDocumentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports